// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"515":"b1c92525","999":"d4a91440"}[chunkId] + ".css";
};